import { CanMatchFn } from '@angular/router';
import { environment } from 'src/environments/environment';

/**
 * featureFlagGuard — a route behind a feature flag must not exist while the
 * flag is off: canMatch returning false lets the URL fall through to the
 * wildcard route ("no such page"), instead of an access-denied redirect that
 * would confirm the module's existence.
 */
export const featureFlagGuard =
  (flag: keyof typeof environment.featureFlags): CanMatchFn =>
  () =>
    environment.featureFlags?.[flag] ?? false;
